<template>
  <div v-loading.fullscreen="loading">
    <div class="header-scroll">
      <div class="header">
        <el-select
          v-model="selectedBoardId"
          style="min-width: 220px"
          @change="onChangeBoard"
        >
          <el-option
            v-for="board in boards"
            :key="board.id"
            :value="board.id"
            :label="
              board.title +
              ' ' +
              board.season +
              '-' +
              'mavsum ' +
              board.year +
              ' yil'
            "
          />
        </el-select>

        <el-button type="success" @click="downloadExcel">
          <img
            src="@/assets/images/icons/download.svg"
            alt=""
            style="margin-right: 5px"
          />
          Excel
        </el-button>
      </div>
    </div>

    <template v-if="regions.length">
      <el-collapse v-model="openRegions" class="region-collapse">
        <el-collapse-item
          v-for="region in regions"
          :key="region.region_id"
          :name="region.region_id"
        >
          <template #title>
            <span class="region-title">{{ region.region_title }}</span>
            <el-tag size="small" type="info" style="margin-left: 10px">
              {{ countInitiatives(region) }} ta tashabbus
            </el-tag>
          </template>

          <el-collapse v-model="openDistricts[region.region_id]" class="district-collapse">
            <el-collapse-item
              v-for="district in region.districts"
              :key="district.district_id"
              :name="district.district_id"
            >
              <template #title>
                <span class="district-title">{{ district.district_title }}</span>
                <el-tag size="small" type="info" style="margin-left: 10px">
                  {{ countDistrictInitiatives(district) }} ta tashabbus
                </el-tag>
              </template>

              <el-collapse v-model="openQuarters[district.district_id]" class="quarter-collapse">
                <el-collapse-item
                  v-for="quarter in district.quarters"
                  :key="quarter.quarter_id"
                  :name="quarter.quarter_id"
                >
                  <template #title>
                    <span class="quarter-title">{{ quarter.quarter_title }}</span>
                    <el-tag size="small" style="margin-left: 10px">
                      {{ quarter.initiatives.length }} ta
                    </el-tag>
                  </template>

                  <el-table :data="quarter.initiatives" border class="initiative-table">
                    <el-table-column type="index" width="50" />
                    <el-table-column label="Tashabbus ID" prop="initiative_public_id" min-width="140" />
                    <el-table-column label="Tashabbus nomi" prop="initiative_description" min-width="280" />
                    <el-table-column label="Deputat" prop="deputy_fullname" min-width="180" />
                    <el-table-column label="Deputat PINFL" prop="deputy_pinfl" min-width="150" />
                    <el-table-column label="Ovozlar soni" prop="vote_count" min-width="110" align="right" />
                    <el-table-column label="Holat" min-width="130">
                      <template #default="scope">
                        <el-tag :type="stageTagType(scope.row.initiative_stage)">
                         {{ scope.row.initiative_stage}}
                        </el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column label="So'ralgan summa" min-width="160" align="right">
                      <template #default="scope">
                        {{ formatAmount(scope.row.requested_amount) }}
                      </template>
                    </el-table-column>
                    <el-table-column label="Ajratilgan summa" min-width="160" align="right">
                      <template #default="scope">
                        {{ formatAmount(scope.row.granted_amount) }}
                      </template>
                    </el-table-column>
                    <el-table-column label="Tanlangan vaqt" min-width="170">
                      <template #default="scope">
                        {{ scope.row.chosen_at ? $moment(scope.row.chosen_at).format("DD-MM-YYYY / HH:mm") : "-" }}
                      </template>
                    </el-table-column>
                  </el-table>
                </el-collapse-item>
              </el-collapse>
            </el-collapse-item>
          </el-collapse>
        </el-collapse-item>
      </el-collapse>
    </template>

    <el-empty v-else-if="!loading" description="Ma'lumot topilmadi" />
  </div>
</template>

<script>
import { ElNotification } from "element-plus";

export default {
  name: "DeputyAudit",
  data() {
    return {
      loading: false,
      boards: [],
      selectedBoardId: null,
      regions: [],
      openRegions: [],
      openDistricts: {},
      openQuarters: {},
    };
  },
  methods: {
    getBoards() {
      this.loading = true;
      this.$http
        .get("api/v1/boards", { params: { status: 1 } })
        .then(({ data }) => {
          this.boards = data.boards || [];
          if (this.boards.length) {
            this.selectedBoardId = this.boards[0].id;
            this.getAuditData();
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onChangeBoard() {
      this.getAuditData();
    },
    getAuditData() {
      if (!this.selectedBoardId) return;
      this.loading = true;
      this.$http
        .get("api/v1/deputy/audit", { params: { board_id: this.selectedBoardId } })
        .then(({ data }) => {
          this.regions = data.regions || [];
          this.openRegions = [];
          this.openDistricts = {};
          this.openQuarters = {};
          // birinchi viloyat, tuman va mahallani ochiq qilish
          if (this.regions.length) {
            const firstRegion = this.regions[0];
            this.openRegions = [firstRegion.region_id];
            if (firstRegion.districts?.length) {
              const firstDistrict = firstRegion.districts[0];
              this.$set
                ? this.$set(this.openDistricts, firstRegion.region_id, [firstDistrict.district_id])
                : (this.openDistricts[firstRegion.region_id] = [firstDistrict.district_id]);
              if (firstDistrict.quarters?.length) {
                const firstQuarter = firstDistrict.quarters[0];
                this.$set
                  ? this.$set(this.openQuarters, firstDistrict.district_id, [firstQuarter.quarter_id])
                  : (this.openQuarters[firstDistrict.district_id] = [firstQuarter.quarter_id]);
              }
            }
          }
        })
        .catch(({ response }) => {
          ElNotification({
            type: "error",
            title: "Xatolik",
            message: response?.data?.message || "Yuklashda xatolik sodir bo'ldi",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    downloadExcel() {
      if (!this.selectedBoardId) return;
      this.loading = true;
      this.$http
        .get("api/v1/deputy/audit/excel", {
          params: { board_id: this.selectedBoardId },
          responseType: "blob",
        })
        .then((res) => {
          const contentDisposition =
            res.headers?.["content-disposition"] ||
            res.headers?.["Content-Disposition"];
          let fileName = "deputy-audit.xlsx";
          if (contentDisposition) {
            const part = contentDisposition
              .split(";")
              .find((item) => item.trim().startsWith("filename="));
            if (part) {
              fileName = decodeURIComponent(
                part.split("=")[1].trim().replace(/^"(.*)"$/, "$1")
              );
            }
          }
          const url = URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        })
        .catch(({ response }) => {
          ElNotification({
            title: "Ogohlantirish",
            message:
              response?.data?.message ||
              "Excel yuklashda xatolik sodir bo'ldi!",
            type: "warning",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    countInitiatives(region) {
      return region.districts.reduce(
        (sum, d) => sum + this.countDistrictInitiatives(d),
        0
      );
    },
    countDistrictInitiatives(district) {
      return district.quarters.reduce((sum, q) => sum + q.initiatives.length, 0);
    },
    stageLabel(stage) {
      const map = {
        INITIAL: "Yangi",
        PASSED: "Qabul qilingan",
        NOT_PASSED: "Rad etilgan",
        WINNER: "G'olib",
        PUBLIC_CONTROL: "Jamoatchilik nazorati",
      };
      return map[stage] || stage;
    },
    stageTagType(stage) {
      const map = {
        INITIAL: "",
        PASSED: "success",
        NOT_PASSED: "danger",
        WINNER: "warning",
        PUBLIC_CONTROL: "info",
      };
      return map[stage] || "";
    },
    formatAmount(amount) {
      if (!amount && amount !== 0) return "-";
      return new Intl.NumberFormat("uz-UZ").format(amount) + " so'm";
    },
  },
  created() {
    if (!window._resizeObserverPatched) {
      const OriginalResizeObserver = window.ResizeObserver;
      window.ResizeObserver = class PatchedResizeObserver extends OriginalResizeObserver {
        constructor(callback) {
          super((entries, observer) => {
            requestAnimationFrame(() => {
              callback(entries, observer);
            });
          });
        }
      };
      window._resizeObserverPatched = true;
    }
  },
  mounted() {
    this.getBoards();
  },
};
</script>

<style scoped>
.header-scroll {
  overflow-x: auto;
  overflow-y: hidden;
  margin-bottom: 16px;
}

.header {
  display: inline-flex;
  gap: 10px;
  align-items: center;
  min-width: max-content;
}

/* Region collapse */
.region-collapse {
  border: none;
}

.region-collapse :deep(.el-collapse-item__header) {
  background-color: #007791;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  padding: 0 16px;
  border-radius: 6px;
  margin-bottom: 2px;
  height: 46px;
  border: none;
}

.region-collapse :deep(.el-collapse-item__header .el-collapse-item__arrow) {
  color: #fff;
}

.region-collapse :deep(.el-collapse-item__wrap) {
  border: none;
  background: transparent;
}

.region-collapse :deep(.el-collapse-item__content) {
  padding: 10px 0 4px 16px;
}

.region-title {
  font-weight: 700;
  font-size: 15px;
}

/* District collapse */
.district-collapse {
  border: none;
}

.district-collapse :deep(.el-collapse-item__header) {
  background-color: #ecf5ff;
  color: #337ecc;
  font-size: 14px;
  font-weight: 600;
  padding: 0 14px;
  border-left: 4px solid #409eff;
  border-radius: 3px;
  margin-bottom: 2px;
  height: 40px;
  border-top: none;
  border-right: none;
  border-bottom: none;
}

.district-collapse :deep(.el-collapse-item__wrap) {
  border: none;
  background: transparent;
}

.district-collapse :deep(.el-collapse-item__content) {
  padding: 8px 0 4px 16px;
}

.district-title {
  font-weight: 600;
  font-size: 14px;
}

/* Quarter collapse */
.quarter-collapse {
  border: none;
}

.quarter-collapse :deep(.el-collapse-item__header) {
  background-color: #f9f9f9;
  color: #606266;
  font-size: 13px;
  font-weight: 600;
  padding: 0 12px;
  border-radius: 3px;
  margin-bottom: 2px;
  height: 36px;
  border-color: #e4e7ed;
}

.quarter-collapse :deep(.el-collapse-item__wrap) {
  border: none;
  background: transparent;
}

.quarter-collapse :deep(.el-collapse-item__content) {
  padding: 8px 0 8px 0;
}

.quarter-title {
  font-weight: 600;
  font-size: 13px;
}

.initiative-table {
  width: 100%;
}
</style>
